import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TranscriptManagementContext } from "../../../contexts/transcriptManagement.context";
import { setGenericModalId } from "../../../Redux/features/modalsSlice";
import { ImSpinner3 } from "react-icons/im";
import { Table } from "../../../components";

const ManagementTable = ({ ViewModal, requestType }) => {
  const [transcriptDetails, setTranscriptDetails] = useState();
  const [currentPage, setCurrentPage] = useState(0); // Server uses 0-based indexing
  const [itemsPerPage] = useState(15);
  const dispatch = useDispatch();

  const { 
    requireReviewTranscripts, 
    getRequireReviewTranscripts, 
    isLoading,
    totalPages,
    totalItems,
    currentPage: serverCurrentPage
  } = useContext(TranscriptManagementContext);

  useEffect(() => {
    getRequireReviewTranscripts(requestType, currentPage, itemsPerPage);
    //eslint-disable-next-line
  }, [currentPage, requestType]);

  // Temporary debug to see what data we're getting
  useEffect(() => {
    console.log('Data received:', {
      requireReviewTranscripts,
      length: requireReviewTranscripts?.length,
      totalPages,
      totalItems,
      isLoading,
      itemsPerPage,
      currentPage,
      isServerPaginated: totalPages > 0 && totalItems > 0
    });
  }, [requireReviewTranscripts, totalPages, totalItems, isLoading]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  // Handle both server-side and client-side pagination
  const isServerPaginated = totalPages > 0 && totalItems > 0;
  const displayData = requireReviewTranscripts || [];
  const displayTotalPages = isServerPaginated ? totalPages : Math.ceil(displayData.length / itemsPerPage);
  const displayTotalItems = isServerPaginated ? totalItems : displayData.length;
  
  // For client-side pagination, slice the data
  const paginatedData = isServerPaginated 
    ? displayData.slice(0, itemsPerPage) // Force limit even for server pagination
    : displayData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  console.log('Pagination debug:', {
    isServerPaginated,
    displayDataLength: displayData.length,
    paginatedDataLength: paginatedData.length,
    itemsPerPage,
    currentPage,
    displayTotalPages,
    displayTotalItems
  });



  const handlePreviewButtonClick = (orderNo) => {
    const temp = requireReviewTranscripts.find(
      (item) => item.requestOrderNumber === orderNo
    );

    // try {

    const {
      // requestOrderNumber,
      // trancriptUseCaseType,
      // address1: destination,
      // address2: secondDestination,
      // city: { name: CityName },
      // country: { name: CountryName },
      // regNumber,
      // student: {
      //   user: { fullName, email, phoneNumber },
      //   admission: {
      //     department: { department_Name: departmentName },
      //   },
      // },
      transcriptDocument,
      // referenceNumber = "",
      // resultType,
      // destinationContactNumber,
      // organisation,
    } = temp;

    const attachingDocumentUrlArray = JSON.parse(
      transcriptDocument[0]?.attachingDocumentUrl || "[]"
    );
    const statementOfResultURL =
      transcriptDocument[0]?.clearanceORpaymentRecieptsUrl;

    const res = {
      requestOrderNumber: temp?.requestOrderNumber,
      trancriptUseCaseType: temp?.trancriptUseCaseType,
      destination: temp?.address1,
      secondDestination: temp?.address2,
      CityName: temp?.city?.name,
      CountryName: temp?.country?.name,
      regNumber: temp?.regNumber,
      
      departmentName:
        temp?.student?.admission?.department?.department_Name,
      fullName: temp?.student?.user?.fullName,
      email: temp?.student?.user?.email,
      phoneNumber: temp?.student?.user?.phoneNumber,
      dateOfBirth: temp?.dateOfBirth,
      educationType: temp?.educationType,
      attachingDocumentUrlArray,
      referenceNumber: temp?.referenceNumber,
      resultType: temp?.resultType,
      destinationContactNumber: temp?.destinationContactNumber,
      organisation: temp?.organisation,
      statementOfResultURL,
    };

    setTranscriptDetails(res);
    dispatch(setGenericModalId("UnprocessedTranscriptView"));
    // } catch (err) {
    //   console.log(err, "Something went wrong");
    // }
  };

  const columns = [
    { value: "Serial No." },
    { value: "Order No." },
    { value: "Full Name" },
    { value: "Request Date" },
    { value: "Matric No." },
    { value: "Shipping Address" },
    { value: "Destination Email" },
    requestType === 3 && { value: "Education Type" },
    { value: "Status" },
    { value: "Actions" },
    // { value: "Actions" },
  ].filter(Boolean);

  // Function to get status display text and styling
  const getStatusDisplay = (status) => {
    switch (status) {
      case 6:
        return {
          text: "Ready to be processed",
          className: "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200"
        };
      case 9:
        return {
          text: "Pending bursary approval",
          className: "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 border border-amber-200"
        };
      default:
        return {
          text: "Unknown",
          className: "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-slate-50 text-slate-700 border border-slate-200"
        };
    }
  };

  const data = paginatedData?.length > 0 ? paginatedData.map((item, index) => {
    const statusInfo = getStatusDisplay(item.status);
    const serialNumber = isServerPaginated 
      ? (currentPage * itemsPerPage) + index + 1 
      : (currentPage * itemsPerPage) + index + 1;
    
    const rowData = {
      "Serial No.": serialNumber,
      "Order No.": item.requestOrderNumber ?? "N/A",
      "Full Name": item.student?.user?.fullName ?? "N/A",
      "Request Date": item.createdAt?.split("T")[0] ?? "N/A",
      "Matric No.": item.regNumber ?? "N/A",
      "Shipping Address": item.address1 ?? "N/A",
      "Destination Email": item.destinationEmail ?? "N/A",
      ...(requestType === 3 && { "Education Type": item.educationType }),
      "Status": (
        <span className={statusInfo.className}>
          {statusInfo.text}
        </span>
      ),
      Actions: (
        <button 
          onClick={() => handlePreviewButtonClick(item.requestOrderNumber)}
          className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200"
        >
          Preview
        </button>
      ),
    };
    return rowData;
  }) : [];



  return (
    <>
      <div className="grid w-full h-full">
        {isLoading ? (
          <ImSpinner3 className="animate-spin place-self-center" size={32} />
        ) : (
          <Table 
            columns={columns} 
            data={data}
            pageCount={displayTotalPages}
            itemCount={displayTotalItems}
            ChangePage={handlePageChange}
            currentPage={currentPage + 1} // Display as 1-based for user
          />
        )}
      </div>
      <ViewModal transcriptDetails={transcriptDetails} />
    </>
  );
};

export default ManagementTable;
